import { Component, Input } from '@angular/core';
import { Route, Router } from '@angular/router';
import { ImportRequest, ImportRequestAds } from 'src/app/domain/models/ImportRequest';
import { ExportOfferUtils } from '../../util/export-offer-utils';
import { environment } from 'src/environments/environment';
import { Routes } from 'src/app/infrastructure/routes';

@Component({
  selector: 'app-import-request-card',
  templateUrl: './import-request-card.component.html',
  styleUrls: ['./import-request-card.component.css']
})
export class ImportRequestCardComponent {

  @Input()
  importRequest: ImportRequestAds | undefined

  formatDate(dateString: Date): string {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = String(date.getFullYear()).slice(-2); // Get last 2 digits of the year

    return `${day}/${month}/${year}`;
  }

  
  constructor(
    private _router: Router,
  ) {}

  navigateToDetail(adsCode: string) {
    this._router.navigate(['/'+ Routes.externalImportRequestDetail, adsCode])
  }

  getImageUrl(offer: ImportRequestAds): string {
    return offer.pictures && offer.pictures.length > 0 ? environment.apiUrl + offer.pictures[0].url : ''
  }

  getIncoterms(value: string) {
    return ExportOfferUtils.getIncotermsName(value)
  }

}
